import { ResourceVendor } from '../../../__generated__/graphql';
import range from 'lodash/range';

export default function appropriateLevels(v: ResourceVendor): string[] {
  const levels = v === ResourceVendor.DormakabaSystem_6000 ? range(1, 21) : range(1, 13);
  return levels.map((level) => level.toString());
}
